<button
  mat-icon-button
  [color]="selectedOption.isUnfilteredOption ? '' : 'primary'"
  [matMenuTriggerFor]="historyFilter"
  matTooltip="Brug filtre"
  matBadgeSize="small"
  matBadge="1"
  [matBadgeHidden]="selectedOption.isUnfilteredOption"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>

<mat-menu #historyFilter="matMenu">
  <div (click)="$event.stopPropagation()">
    <mat-radio-group class="history-radio-group">
      @for (selectOption of filterOptions; track selectOption) {
        <mat-radio-button
          class="history-radio-button"
          [value]="selectOption.id"
          [checked]="selectOption.id == selectedOption.id"
          (change)="filterChanged($event)"
          >
          {{ selectOption.text }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</mat-menu>
